module.exports = __webpack_public_path__ + "img/docker.62132fc4.jpg";